import React, { PureComponent } from 'react';

import { SyncLoader } from 'react-spinners';

import { Mask } from './';

export class ServerLoading extends PureComponent {

  render() {
   return(
    this.props.loading
    ? <Mask style={{ justifyContent: 'start', alignItems: 'start', paddingTop: '14vh', paddingLeft: 10}}>
      <div style={{
          display: 'flex',
          position: 'relative',
          justifyContent: 'start',
          alignItems: 'center'
        }}>
        <SyncLoader color={'#eee'} />
        <div style={{ flex: 4, marginLeft: 15 }}>Le serveur enregistre les données</div>
      </div>
      </Mask>
    : null
   );
  }
}